import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig, profile } from 'config/config'; // Importing configuration settings

export default class tableBalanceAdjustmentsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Main view type
            id: 'datatable', // Unique identifier for the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            scrollY: true, // Enable vertical scrolling
            columns: [
                // Column definitions for the datatable
                { id: 'Id', header: 'Id', width: 100, sort: 'int' }, // Column for Id
                {
                    id: 'DateAt',
                    header: _('Fecha'), // Localized header for Date
                    fillspace: 0,
                    minWidth: 0,
                    width: 200,
                    sort: 'text', // Sorting type
                    format: dateFormat, // Date format for display
                },
                { id: 'Type', header: _('Tipo'), width: 200, sort: 'int' }, // Column for Type
                { id: 'UserTo', header: _('Emisor'), width: 300, sort: 'int' }, // Column for UserTo
                {
                    id: 'ReferenceId',
                    header: _('Referencia'), // Localized header for Reference
                    width: 200,
                    sort: 'int',
                },
                {
                    id: 'Description',
                    header: _('Descripción'), // Localized header for Description
                    width: 500,
                    sort: 'int',
                },
            ],
            on: {
                // Event handlers for the datatable
                onBeforeLoad: function () {
                    // Before loading data
                    this.showOverlay(
                        // Show loading overlay
                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                    );
                },
                onAfterLoad: function () {
                    // After loading data
                    this.hideOverlay(); // Hide loading overlay
                },
            },
            ready: function () {
                // When the datatable is ready
                if (!this.count()) {
                    // Check if there are no items
                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                    this.showOverlay(
                        // Show no data overlay
                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                            _('No hay datos') + // Localized no data message
                            '</div>',
                    );
                }
            },
            tooltip: true, // Enable tooltips
            math: true, // Enable math operations
            loadahead: 0, // Load ahead configuration
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
            pager: 'pagerA', // Pager ID for pagination
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        var filter = ''; // Filter string for data fetching
        const cur_user = this.getParam('user', true); // Current user parameter
        var url = devConfig.geturlApi() + 'Client/GetNotes'; // API endpoint for fetching notes
        var options = []; // Options for the note types
        var popupAdd; // Popup for adding notes

        // Event listener for filtering data
        this.on(this.app, 'filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filters
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&DateFrom=' + date[0];
                        string1 = string1 + '&DateTo=' + date[1];
                    } else {
                        if (object[i][0] != 'Date') {
                            // Handle other filters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date filter
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&DateFrom=' + date;
                                string1 = string1 + '&DateTo=' + date;
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&UserTo=' + cur_user; // Append current user to filter
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter variable
        });

        // Event listener for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user event with item Id
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data based on selected player
            );
        });

        // AJAX request to fetch note types
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type for request
            })
            .post(devConfig.geturlApi() + 'Select/GetNoteTypes', '', {
                error: function (text, data, XmlHttpRequest) {
                    // Error handling
                    webix.message('Error! '); // Show error message
                },
                success: function (text, data, XmlHttpRequest) {
                    // Success handling
                    var resp = JSON.parse(text); // Parse response
                    resp.Data.forEach((item) => {
                        // Iterate through note types
                        item.id = item.Id; // Map Id to id
                        item.value = item.Description; // Map Description to value
                    });
                    options = resp.Data; // Store options
                    $$('Type').define('options', resp.Data); // Define options for Type combo
                    $$('Type').refresh(); // Refresh Type combo
                    popupAdd = webix.ui({
                        // Create popup for adding notes
                        view: 'window',
                        id: 'AddNote',
                        width: 450,
                        height: 450,
                        fullscreen: screen.width > 500 ? false : true, // Fullscreen based on screen width
                        head: {
                            view: 'toolbar',
                            cols: [
                                {
                                    view: 'label',
                                    label: _('Crear Nota'), // Localized label for creating note
                                    align: 'center',
                                },
                                {
                                    view: 'icon',
                                    icon: 'wxi-close', // Close icon
                                    click: function () {
                                        this.getTopParentView().hide(); // Hide popup on close
                                    },
                                },
                            ],
                        },
                        position: 'center', // Center position for popup
                        modal: true, // Modal popup
                        body: {
                            view: 'form', // Form for note input
                            id: 'addform',
                            elements: [
                                {
                                    view: 'combo',
                                    label: _('Tipo') + ':', // Localized label for Type
                                    name: 'Type',
                                    required: true, // Required field
                                    options: options, // Options for Type
                                    labelWidth: 150,
                                },
                                {
                                    view: 'textarea',
                                    label: _('Descripción:'), // Localized label for Description
                                    name: 'Description',
                                    labelWidth: 150,
                                    required: true, // Required field
                                },
                                {
                                    view: 'text',
                                    label: _('Referencia:'), // Localized label for Reference
                                    name: 'ReferenceId',
                                    labelWidth: 150,
                                    required: true, // Required field
                                },
                                {
                                    cols: [
                                        {
                                            view: 'button',
                                            value: _('Cancelar'), // Localized label for Cancel button
                                            click: function () {
                                                this.getTopParentView().hide(); // Hide popup on cancel
                                                $$('addform').setValues(
                                                    // Reset form values
                                                    $$('addform').getCleanValues(),
                                                );
                                            },
                                        },
                                        {
                                            view: 'button',
                                            type: 'form',
                                            value: _('Guardar'), // Localized label for Save button
                                            click: function ($e) {
                                                var values = $$('addform').getValues(); // Get form values
                                                if ($$('addform').validate()) {
                                                    // Validate form
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json', // Set content type for request
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'Client/CreateNote', // API endpoint for creating note
                                                            '{"UserTo":"' +
                                                                cur_user +
                                                                '", "Type":"' +
                                                                values.Type +
                                                                '", "Description":"' +
                                                                values.Description +
                                                                '", "ReferenceId":"' +
                                                                values.ReferenceId +
                                                                '"}', // JSON payload
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    // Error handling
                                                                    webix.message(
                                                                        'Error! ', // Show error message
                                                                    );
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    // Success handling
                                                                    var json = JSON.parse(
                                                                        text, // Parse response
                                                                    );
                                                                    if (
                                                                        json.HasError // Check for errors in response
                                                                    ) {
                                                                        webix.message({
                                                                            title: _(
                                                                                '¡Error!', // Localized error title
                                                                            ),
                                                                            type: 'alert-error',
                                                                            text: json.AlertMessage, // Show alert message
                                                                        });
                                                                    } else {
                                                                        webix.message(
                                                                            'Nota Creada', // Show success message
                                                                        );
                                                                        grid.clearAll(); // Clear grid data
                                                                        grid.load(
                                                                            url +
                                                                                '?start=0&count=' +
                                                                                grid.data.$pagesize +
                                                                                filter, // Reload grid data
                                                                        );
                                                                    }
                                                                },
                                                            },
                                                        );
                                                    $$('addform').setValues(
                                                        // Reset form values
                                                        $$('addform').getCleanValues(),
                                                    );
                                                    this.getTopParentView().hide(); // Hide popup after saving
                                                } else {
                                                    webix.message({
                                                        title: _('¡Error!'), // Localized error title
                                                        type: 'alert-error',
                                                        text: _(
                                                            'Completa los campos...', // Localized error message
                                                        ),
                                                    });
                                                }
                                            },
                                        },
                                    ],
                                },
                            ],
                            elementsConfig: {
                                on: {
                                    onChange: function () {
                                        this.validate(); // Validate fields on change
                                    },
                                },
                            },
                        },
                    });
                },
            });

        // Event listener for adding adjustments
        this.on(this.app, 'addAdjustment:button', (item) => {
            if (options.length > 0) {
                // Check if options are available
                popupAdd.show(); // Show add note popup
                $$('addform').clearValidation(); // Clear validation messages
            } else {
                webix.message({
                    text: _('Datos no han podido ser cargados'), // Localized error message
                    title: _('¡Error!'), // Localized error title
                    type: 'alert-error',
                });
            }
        });
    }
}

// FILE DOCUMENTED
